import { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { format } from 'date-fns';

import {
  NetIncomeAddon,
  BalanceAddon,
  LiabilitiesAddon,
  SpacesAddon,
  PageTitle,
} from 'containers';

import DateRangeIcon from '@material-ui/icons/DateRange';
import { PageLoader, Error, Addon } from 'components';

import clsx from 'clsx';
import { useStyles } from './style';

interface Props {
  periodEndingDate: Date | null;
  loading: boolean;
  error: boolean;
}

const InvestorHomeDetails: React.FC<Props> = ({
  periodEndingDate,
  loading,
  error,
}) => {
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation();

  const moveToBalancePage = useCallback(
    () => {
      history.push('/investor/investor-balance');
    },
    /* eslint-disable-next-line */
    []
  );

  const moveToSpacesPage = useCallback(() => {
    history.push('/investor/spaces');
  }, []);

  if (loading) {
    return <PageLoader />;
  }

  if (error) {
    return <Error />;
  }

  return (
    <>
      <div className={classes.topBar}>
        <div className={classes.wrapper}>
          <PageTitle />
        </div>
        <div className={clsx(classes.wrapper, classes.wrapperRight)}>
          <DateRangeIcon className={classes.dateIcon} />
          <span className={classes.text}>
            {t('#portal.investor.dashboard.enddate')}:{' '}
            {periodEndingDate ? format(periodEndingDate, 'd.M.yyyy') : null}
          </span>
        </div>
      </div>
      <div className={classes.flex}>
        <div className={classes.parent}>
          <Addon>
            <NetIncomeAddon periodEndingDate={periodEndingDate} />
          </Addon>
        </div>
        <div className={classes.parent}>
          <Addon
            action={moveToBalancePage}
            title={t('#portal.investor.dashboard.balances.toreport') as string}
          >
            <BalanceAddon />
          </Addon>
        </div>
        <div className={classes.parent}>
          <Addon>
            <LiabilitiesAddon />
          </Addon>
        </div>
        <div className={classes.parent}>
          <Addon
            action={moveToSpacesPage}
            title={t('#portal.investor.dashboard.spaces.tolist') as string}
          >
            <SpacesAddon />
          </Addon>
        </div>
      </div>
    </>
  );
};

export default memo(InvestorHomeDetails);
